import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { fetchMyProjects, setCurrentProjectId } from "@/actions";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import StaticLayoutInner from '@/layouts/StaticLayoutInner';
import ProjectAvatar from '@/components/ProjectAvatar';
import { getUserStatus } from '@/utils/utils';
import ArrowRight from '@/images/icons/ArrowRight';

export default function TransferredProject() {
	let navigate = useNavigate();
	let dispatch = useDispatch();
	let location = useLocation();

	let auth = useSelector(state => state.auth);
	let myIds = useSelector(state => state.project.myIds);
	let byId = useSelector(state => state.project.byId);
	const [searchParams, updateSearchParams] = useSearchParams();

	const [projectName, setProjectName] = useState(location.state?.projectName || null);
	const [telegramId, setTelegramId] = useState(location.state?.telegramId || null);

	useEffect(() => {
		dispatch(setCurrentProjectId(null));
		dispatch(fetchMyProjects(auth.user.token));
	}, []);

	useEffect(() => {
		let projectId = searchParams.get("projectId");
		if (myIds?.list && myIds?.list.indexOf(projectId) > -1) {
			dispatch(setCurrentProjectId(projectId, null));
			navigate("/");
		}
	}, [myIds])

	let projects = myIds.list.map((projectId, i) =>
		<button
			key={`project-select-${projectId}`}
			className="flex items-center py-[14px] px-3 sm:p-4 w-full text-white text-sm font-medium bg-[#1A1C1D] rounded-xl border-b border-b-[#313334] hover:bg-[#313334] transition relative"
			data-project-id={projectId}
			onClick={(e) => {
				dispatch(setCurrentProjectId(e.currentTarget.dataset.projectId, null));
				navigate("/");
			}}
		>
			<ProjectAvatar className="min-w-8 w-8 h-8 rounded-full" project={byId[projectId]} />
			<div className="flex truncate w-full pr-4">
				<div className="ml-3 mr-2 w-[calc(100%-20px)]">
					<div className="truncate text-sm text-left font-medium mb-0.5">{byId[projectId].name}</div>
					<div className="text-[11px]/[1.1] font-medium text-[#A5A5A5] text-left">{getUserStatus({
						user: auth?.user,
						project: byId[projectId]
					}, 'status')}</div>
				</div>
			</div>
			<ArrowRight className="absolute top-0 right-3 bottom-0 left-auto m-auto w-5 h-5" />
		</button>
	);

	return (
		<StaticLayoutInner hideSidebar centerContent>
			<div className="flex flex-col m-auto">
				<div className="max-w-[488px] m-auto text-center">
					{projectName && telegramId && (
						<h1 className="h1 mb-4 md:mb-6">
							You have successfully transferred the <span className="text-[#3CBBCE]">{projectName}</span> project to ID<span className="text-[#3CBBCE]">{telegramId}</span>
						</h1>
					)}
					{myIds.isFetching ? (
						<div className="flex items-center justify-center py-1 mt-10 mb-10">
							<svg className="animate-rotation w-10 h-10"
							     width="24"
							     height="24"
							     viewBox="0 0 24 24"
							     fill="none"
							     xmlns="http://www.w3.org/2000/svg">
								<path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2" stroke="white" strokeWidth="3" strokeLinecap="round"/>
								<path d="M12 2C11.4467 2 10.9039 2.04494 10.375 2.13136" stroke="white" strokeWidth="3" strokeLinecap="round"/>
								<path d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2" stroke="#8A9698" strokeWidth="3" strokeLinecap="round"/>
							</svg>
						</div>
					) : (
						<>
							{myIds && myIds.isFetched && myIds.list.length > 0 && (
								<>
									<div className="mb-8 md:mb-12">You can proceed with your tasks in different workspaces.</div>
									<div className="flex flex-col gap-4 max-w-80 mx-auto">
										{projects}
									</div>
								</>
							)}
							{myIds && myIds.isFetched && myIds.list.length === 0 && (
								<>
									<div>Create a new bot to continue working.</div>
									<a className="btn-primary mt-6 md:mt-10 max-w-[268px] w-full"
									   href="https://t.me/InviteMemberBot?start=create_project"
									   target="_blank"
									   rel="noopener noreferrer"
									>
										Create a new bot
									</a>
								</>
							)}
						</>
					)}
				</div>
			</div>
		</StaticLayoutInner>
	);
}

